// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2TEPy","title":"BackImages_title__2oY5Q","images":"BackImages_images__3kRNB"};